import { InternalMovementList } from 'components/hr-metrics/internal-movement/InternalMovementList'
import { INITIAL_DATA_QUERY } from 'configs/hr-metrics/configTableInternalMovementList'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { API_INTERNAL_MOVEMENT } from 'services/apiInternalMovement'
import { useFetch } from 'services/useFetch'
import { downloadFile, getAllQueryParams, setQueryParams } from 'utils/utils'

const FILTER_PARAMS = ['department_ids', 'division_ids', 'grade_ids', 'change_types']

const TAB_STATUS = [
    { id: 'active', name: 'active' },
    { id: 'inactive', name: 'inactive' },
]

const InternalMovementListContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const status = searchParams.get('status')
    const [queryFilter, setQueryFilter] = useState()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_QUERY
    const [isShowToast, setIsShowToast] = useState(false)
    const [toastMessage, setToastMessage] = useState('')
    const [selectedIds, setSelectedIds] = useState([])
    const [itemPreview, setItemPreview] = useState(null)
    const [modal, setModal] = useState({
        export: false,
        import: false,
        limit: false,
        preview: false,
    })
    const {
        data: internalMovementList,
        fetching: getInternalMovement,
        isLoading,
    } = useFetch(API_INTERNAL_MOVEMENT.LIST)
    const { fetching: exportInternalMovementList } = useFetch(API_INTERNAL_MOVEMENT.EXPORT)
    const {
        data: dataPreview,
        fetching: getInternalMovementPreview,
        isLoading: isLoadingPreview,
    } = useFetch(API_INTERNAL_MOVEMENT.PREVIEW)

    useEffect(() => {
        getInternalMovementList({ ...query })
    }, [location?.search])

    const getInternalMovementList = async () => {
        const newQuery = { ...query }
        const newQueryFilter = {}
        Object.entries(newQuery).forEach(([key, item]) => {
            if (FILTER_PARAMS.includes(key)) {
                const valueOfQuery = FILTER_PARAMS.includes(key) ? item.split(',') : item
                newQuery[key] = valueOfQuery
                newQueryFilter[key] = valueOfQuery
            }
        })
        setQueryFilter(newQueryFilter)
        getInternalMovement(newQuery)
    }

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const onChangeTab = (status) => {
        onChangeQuery({ page: 1, status: status.id })
    }

    const clearToast = () => {
        setIsShowToast(false)
        setToastMessage('')
    }

    const setShowModal = (value) => {
        setModal({ ...modal, ...value })
    }

    const onClickItemHandler = (item) => {
        setItemPreview(item)
        getInternalMovementPreview(null, item.id)
        setShowModal({ preview: true })
    }

    const onExportHandler = () => {
        const body = { ...query, 
            department_ids: queryFilter?.department_ids || [],
            division_ids: queryFilter?.division_ids || [],
            grade_ids: queryFilter?.grade_ids || [],
            change_types: queryFilter?.change_types || [],
            ids: selectedIds.map((item) => item.id),
        }

        exportInternalMovementList(body, '', {}, 'blob').then((res) => {
            downloadFile(null, res, `Internal-Movement-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
            setShowModal({ export: false })
            setIsShowToast(true)
            setToastMessage('Export Data Berhasil !!')
        })
    }

    const onHideImport = (isComplete) => {
        setShowModal({ import: false })
        if (isComplete) {
            getInternalMovementList()
        }
    }

    const props = {
        dataList: internalMovementList?.data,
        dataPreview: {
            name: itemPreview?.full_name,
            nip: itemPreview?.nip,
            history: dataPreview?.data,
        },
        isLoading,
        isLoadingPreview,
        query,
        queryFilter,
        toast: {
            isShowToast,
            message: toastMessage,
        },
        tabStatus: TAB_STATUS,
        status: status || TAB_STATUS[0].id,
        modal,
        selectedIds,
        setShowModal,
        setSelectedIds,
        clearToast,
        onChangeTab,
        onChangeQuery,
        onClickItemHandler,
        onExportHandler,
        onHideImport,
    }

    return <InternalMovementList {...props} />
}

export default InternalMovementListContainer
